module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitlefw"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "ts2"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryff"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_intro#intro"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Introduction: First All-Rounder")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryfBb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_photo#photo"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Photograph Sources")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_ch01#ch01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Heir Apparent – T-54")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Up Close and Personal")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Fine Tuning – T-55")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("T-54/55 Specialized Variants")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Warsaw Pact Copies")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Chinese Cousins")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Middle-Eastern Upgrades")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Darling of the Left")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Desert Failure")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/18_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("European Swansong")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1w"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("How to Win Friends")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryfTv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_posts#post",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Postscript: ‘Soviet made shit’")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryff"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_further#fur",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ts2"
  }, [_vm._v("Further Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0